<template>
  <TxtPage>
    
    <div slot="return-content" class="btn-return">
      <router-link :to="{ name: 'Appartement' }">
        <img src="../../assets/arrow.svg" />
      </router-link>  
    </div>
    
    <div slot="left-content" class="spacer-content"> 
    
      <div class="title-book">RAFFINEMENT ET MODERNITÉ</div>
      <div class="title-light">DANS LES MOINDRES DÉTAILS</div>
      
      <div class="line"></div>
      <p class="text-center">Une ambiance et une élégance dans les moindres détails pour vous offrir, jour après jour, un confort intérieur inégalable. </p>
      
      <div class="title mt40">INTÉRIEURS</div>
      <div class="text">
        <ul class="list-style-custom">
          <li>Pour garantir des espaces de vie tempérés, le chauffage s’effectue par le sol dans le séjour, la cuisine et les chambres.</li> 
          <li>Le parquet en chêne massif, coloris au choix, revêt le sol de toutes les pièces sèches. </li> 
          <li>Les murs et plafonds des pièces de vie sont revêtus d’une peinture blanche.</li> 
          <li>Les murs des salles de bains et salles d’eau sont habillées sur 3 murs d’une élégante faïence toute hauteur, teinte à sélectionner dans la collection proposée.</li>  
          <li>Celles-ci accueillent une baignoire ou un receveur de douche extra-plat, équipées de meuble vasque et sèche-serviette mixte. </li> 
          <li>Les WC séparés sont pourvus d’un lave-main et de sanitaires suspendus. </li> 
          <li>Le sol des pièces humides se pare d’un carrelage, plusieurs teintes au choix. </li> 
          <li>Des placards sont aménagés pour optimiser votre espace.</li> 
          <li>Pour être chez-soi en toute sécurité, la porte palière est blindée et est munie d’une serrure de sûreté 5 points A2P**.</li> 
        </ul>
      </div>
      <div class="line"></div>
      
      <div class="title mt40">EXTÉRIEURS </div>
      <div class="text">
        <ul class="list-style-custom">
          <li>Les terrasses, balcons et loggias se parent de dalles en grès cérame effet bois. </li> 
        </ul>
      </div>
      <div class="line"></div>
      
      <div class="title mt40">PARTIES COMMUNES </div>
      <div class="text">
        <ul class="list-style-custom">
          <li>Les accès aux sas d’entrées, décorés par les architectes, sont sécurisés par un vidéophone à écran tactile 16/9° pour les visiteurs et par un badge Vigik&#174; pour les résidants. </li> 
          <li>Un jardin pédagogique vous offre la possibilité de vous essayer aux plantations. </li> 
        </ul>
      </div>
      <div class="line"></div>
      
      <div class="title mt40">INNOVATIONS ET SERVICES</div>
      <div class="text">
        <ul class="list-style-custom">
          <li>Pour une démarche toujours plus éco-responsable la toiture est pourvue de panneaux solaires. </li> 
          <li>Un service de boîtes aux lettres connectées vous permet d’être prévenu en temps réel de la réception d’un colis. </li> 
          <li>Une conciergerie digitale et une application pour communiquer avec votre syndicat de copropriété sont mise à votre disposition pour un quotidien plus pratique. </li> 
          <li>Salle de fitness, salle de bricolage, bibliothèque, station de réparation pour les vélos, une multitude d’opportunités pour profiter de votre temps libre sans vous déplacer.</li> 
        </ul>
      </div>
      <div class="line"></div>
      
      <div class="btn-scroll"><img src="../../assets/scroll.svg" /></div>
      
    </div>
    
    <div slot="right-content">
      <img src="../../assets/pers-appartement-prestations.jpg" class="cover-center"/>
    </div>
    
  </TxtPage>
</template>

<style lang="scss" scoped>
  .title-book {
    font-size: 32px;
    text-align: center;
    font-family: 'FuturaStd-Book';
  }
  .title-light {
    font-size: 32px;
    text-align: center;
    margin-bottom: 40px;
  }
  .text {
    .list-style-custom {
      margin: 0 !important;
    }
    margin-bottom: 0 !important;
  }  
  .mt40 {
    margin-top: 40px;
  }
  .cover-center{
    @media (min-width: 992px) {
      -o-object-position: -60% !important;
      object-position: -60% !important;
    }
  }
</style>

<script>
import TxtPage from '@/components/TxtPage.vue';
// @ is an alias to /src

export default {
    name: 'VotreInterieur',
    components: {
        TxtPage
    },
    data: () => {
    
        return {
        
            links: [
            ],
            visible: true
        
        };
    }


}
</script>